const themes = {
    global: {
        black: '#000000',
        white: '#ffffff',
        darkgray: '#e5e5e5',
        lightgray: '#f2f2f2',
        darkShade1: '#262626',
        darkShade2: '#404040'
    },
    publismart: {
        shade1: '#18a4e0',
        shade2: '#384041',
        shade3: '#48ad8b',
        place: '#48ad8b',
        logo: 'logo_smart-mobility.svg',
        marker: 'ic_marker_publismart.svg'
    },
    dudelange: {
        shade1: '#e43426',
        shade2: '#e43426',
        shade3: '#e43426',
        place: '#e43426',
        navBackgroundActive: '#ffffff',
        logo: 'logo_dudelange.svg'
    },
    rumelange: {
        shade1: '#a81c36',
        shade2: '#a81c36',
        shade3: '#a81c36',
        place: '#a81c36',
        navBackgroundActive: '#ffffff',
        navActive: '#ffffff',
        maptype: 'geoportail',
        logo: 'logo_rumelange.svg'
    },
    diekirch: {
        shade1: '#A19556',
        shade2: '#278DCB',
        shade3: '#A19556',
        place: '#D8232A',
        navBackgroundActive: '#ffffff',
        navActive: '#ffffff',
        logo: 'logo_diekirch.svg'
    },
    erpeldange: {
        shade1: '#3bab36',
        shade2: '#00a3e3',
        shade3: '#3bab36',
        navBackgroundActive: '#ffffff',
        navActive: '#ffffff',
        place: '#00a3e3',
        logo: 'logo_erpeldange-sur-sure.svg'
    },
    hesperange: {
        shade1: '#ed1c24',
        shade2: '#ed1c24',
        shade3: '#25408f',
        place: '#ed1c24',
        navBackgroundActive: '#ffffff',
        logo: 'logo_hesperange.svg'
    },
    bettendorf: {
        shade1: '#ed0039',
        shade2: '#959da7',
        shade3: '#8f7e43',
        place: '#ed1c24',
        logo: 'logo_hesperange.svg'
    },
    mertert: {
        shade1: '#ffffff',
        shade2: '#0075b5',
        shade3: '#c71717',
        navBackgroundActive: '#e09670',
        place: '#c71717',
        logo: 'logo_mertert.svg',
        // marker: 'ic_marker_mertert.png'
    },
};

export default themes;
